<template>
    <div class="container">
        <div class="row">
            <div class="col-12">
                <emblem>Ledenoverzicht</emblem>
                <div v-html="translations.text"></div>
            </div>
        </div>

        <div class="row mb-3">
            <div class="col-12 col col-md-8 col-lg-6 col-xl-4">
                <div
                    class="search-category flex-column flex-sm-row flex d-flex align-items-sm-center"
                >
                    <div class="radio-input">
                        <input
                            id="companies"
                            v-model="form.searchCategory"
                            type="radio"
                            name="searchCategory"
                            value="companies"
                            class="position-relative mr-1"
                        />
                        <label class="pr-2 mb-0" for="companies">{{
                            translations.companies
                        }}</label>
                    </div>
                    <div class="radio-input">
                        <input
                            id="groups"
                            v-model="form.searchCategory"
                            type="radio"
                            name="searchCategory"
                            value="groups"
                            class="position-relative mr-1"
                        />

                        <label class="pr-2 mb-0" for="groups">{{
                            translations.groups
                        }}</label>
                    </div>
                    <div class="radio-input">
                        <input
                            id="members"
                            v-model="form.searchCategory"
                            type="radio"
                            name="searchCategory"
                            value="members"
                            class="position-relative mr-1"
                        />
                        <label class="mb-0" for="members">{{
                            translations.members
                        }}</label>
                    </div>
                </div>
                <div class="search-input">
                    <div class="search-input__container">
                        <input
                            v-model="form.searchQuery"
                            class="search-input__field w-100"
                            type="search"
                            :placeholder="
                                '   Zoeken op ' + searchCategoryLabel
                            "
                        />
                    </div>
                </div>
            </div>
        </div>

        <div v-if="loading" class="row">
            <div class="col text-center mt-3 mb-3">
                <div class="emblem emblem--loader"></div>
            </div>
        </div>

        <div v-if="!loading && error" class="col text-center">
            <p>
                Er ging iets mis bij het ophalen van de gegevens. Probeer het
                later opnieuw.
            </p>
        </div>

        <div
            v-if="
                !loading &&
                    !error &&
                    (searchResults === null || !searchResults.length)
            "
            class="col text-center"
        >
            <p>{{ translations.emptyResult }}</p>
        </div>

        <v-collapse-group :only-one-active="true">
            <transition-group
                ref="startOfResults"
                tag="div"
                name="staggered-fade"
                :css="false"
                class="row"
                @before-enter="beforeEnter"
                @enter="enter"
                @leave="leave"
            >
                <v-collapse-wrapper
                    v-for="(cardData, index) in searchResults"
                    :key="cardData.id"
                    :class="'d-flex flex-column col-lg-4 col-sm-6'"
                >
                    <component
                        :is="form.searchCategory"
                        :read-more="translations"
                        :card-data="cardData"
                        :data-index="index"
                        @update="updateIdQuery"
                    />
                </v-collapse-wrapper>
            </transition-group>
        </v-collapse-group>

        <paging
            v-model="currentPage"
            :total-pages="totalPages"
            :disabled="loading"
            @input="scrollToResults"
        />
    </div>
</template>

<script>
import Axios from 'axios';
import emblem from '@/components/emblem';
import memberCard from '@/components/members/member-card';
import bankGroupCard from '@/components/members/bank-group-card';
import bankCompanyCard from '@/components/members/bank-company-card';
import paging from '@/components/navigation/paging';
import overview from '@/mixins/overview.js';
import transition_staggered_fade from '@/mixins/transition-staggered-fade-mixin.js';
import translationMixin from '@/mixins/translations';

export default {
    components: {
        emblem,
        members: memberCard,
        companies: bankCompanyCard,
        groups: bankGroupCard,
        paging
    },

    mixins: [overview, transition_staggered_fade, translationMixin],

    data() {
        return {
            currentPage: 1,
            totalPages: 1,
            error: false,
            isCompanySearch: false,
            oldForm: {
                searchCategory: 'companies',
                searchQuery: '',
                idQuery: ''
            },
            form: {
                searchCategory: 'companies',
                searchQuery: '',
                idQuery: ''
            }
        };
    },
    computed: {
        searchCategoryLabel() {
            return this.translations[this.form.searchCategory];
        }
    },
    watch: {
        form: {
            handler(val) {
                const oldVal = this.oldForm;

                if (this.isCompanySearch && val.idQuery !== oldVal.idQuery) {
                    this.form.searchCategory = 'members';
                    this.form.searchQuery = '';
                }

                if (
                    !this.isCompanySearch &&
                    val.searchCategory !== oldVal.searchCategory
                ) {
                    this.form.searchQuery = '';
                    this.form.idQuery = '';
                }

                if (
                    !this.isCompanySearch &&
                    val.searchQuery !== oldVal.searchQuery
                ) {
                    this.form.idQuery = '';
                }

                Object.assign(this.oldForm, val);
                this.searchResults = [];
                this.currentPage = 1;
                this.isCompanySearch = false;

                if (this.timeout) {
                    clearTimeout(this.timeout);
                }
                this.timeout = setTimeout(() => {
                    this.getItems();
                }, 400);
            },
            deep: true
        },

        currentPage() {
            this.searchResults = [];
            this.getItems();
        }
    },
    methods: {
        getItems() {
            clearInterval(this.elapsed);
            this.loading = true;

            const getUrl =
                '/api/v1/domainapi/allmembers?type=' +
                this.form.searchCategory +
                '&take=' +
                this.loadItems +
                '&page=' +
                this.currentPage +
                '&contentid=' +
                this.$root.settings.currentPage +
                '&q=' +
                this.form.searchQuery +
                '&q2=' +
                this.form.idQuery;

            Axios.get(getUrl)
                .then(response => {
                    if (response.data !== null) {
                        this.searchResults = response.data.items;
                        this.resultsCount = response.data.count;
                        this.totalPages = response.data.pages;
                    }
                })
                .catch(() => {
                    this.error = true;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        scrollToResults() {
            const element = this.$refs['startOfResults'];
            window.scrollTo({
                top: element.offsetTop - 300,
                behavior: 'smooth'
            });
        },

        updateIdQuery(event) {
            this.isCompanySearch = true;
            this.form = Object.assign({}, this.form, { idQuery: event });
        }
    }
};
</script>

<style lang="scss" scoped>
.search-input {
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.2);
    margin-top: 10px;
}

.search-input__field {
    height: 40px;
    padding: 0 20px;
}

.search-category label {
    cursor: pointer;
}

.search-category input {
    width: 12px;
    height: 12px;
}

.search-category input:after {
    content: '';
    width: 12px;
    height: 12px;
    background-color: $brand-white;
    position: absolute;
    border-radius: 90px;
    top: 50%;
    transform: translateY(-50%);
}

.search-category input:checked:after {
    background-color: $brand-blue;
}
</style>
